export const FIELDS = {

  ID: 'id',
  SODATE: 'soDate',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  DUE_DATE: 'dueDate',
  COMPANY_ID: 'companyId',
  CONTACT_ID: 'contactId',
  BILLING_ADDRESS: 'billingAddress',
  SHIP_TO_ADDRESS: 'shippingAddress',
  BUYER_USER_ID: 'buyerUserId',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  BILLING_TERM_ID: 'billingTermId',
  COMMENTS: 'comments',
  INTERNAL_COMMENTS: 'internalComments',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  SHIP_ON_VENDOR_ACCOUNT: 'shipOnVendorAccount',
  SHIPPING_ACCOUNT_NUMBER: 'shippingAccountNumber',
  TRACKING_NUMBER: 'trackingNumber',
  TEST_HOUSE_QUOTE_NUMBER: 'testHouseQuoteNumber',
  STATUS_ID: 'statusId',
  SALES_TYPE_ID: 'salesTypeId',
  INCO_TERM_ID: 'incoTermId',
  IS_TAXABLE: 'isTaxable',
  SHIPPING_NO_CHARGE: 'shippingNoCharge',
  TAX_RATE: 'taxRate',
  EXCHANGE_RATE: 'exchangeRate',
  SHIPPING_CHARGE: 'shippingCharge',
  SUB_TOTAL: 'subTotal',
  TOTAL_LINE_COST: 'totalLineCost',
  TOTAL_CHARGES_TAXABLE: 'totalChargesTaxable',
  TOTAL_CHARGES_NON_TAXABLE: 'totalChargesNonTaxable',
  TOTAL_CHARGES: 'totalCharges',
  TOTAL_CHARGES_COST: 'totalChargesCost',
  TAX: 'tax',
  CREDIT: 'credit',
  TOTAL: 'total',
  SUB_TOTAL_CONVERTED: 'subTotalConverted',
  TOTAL_LINE_COST_CONVERTED: 'totalLineCostConverted',
  TOTAL_CHARGES_TAXABLE_CONVERTED: 'totalChargesTaxableConverted',
  TOTAL_CHARGES_NON_TAXABLE_CONVERTED: 'totalChargesNonTaxableConverted',
  TOTAL_CHARGES_CONVERTED: 'totalChargesConverted',
  TOTAL_CHARGES_COST_CONVERTED: 'totalChargesCostConverted',
  TOTAL_CONVERTED: 'totalConverted',
  AMOUNT_PAID: 'amountPaid',
  IS_PAID: 'isPaid',
  ON_HOLD: 'onHold',
  IS_AUTHORIZED: 'isAuthorized',
  AUTHORIZED_BY_USER_ID: 'authorizedByUserId',
  DATE_AUTHORIZED: 'dateAuthorized',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_SENT: 'dateSent',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  PODATE: 'poDate',
  COMPANY_NAME: 'companyName',
  CONTACT_FULL_NAME: 'contactFullName',
  CONTACT_EMAIL: 'contactEmail',
  FULL_NAME: 'fullName',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  BILLING_TERM_NAME: 'billingTermName',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  SHIPPING_METHOD_NAME: 'shippingMethodName',
  STATUS_NAME: 'statusName',
  SALES_TYPE_NAME: 'salesTypeName',
  INCO_TERM_NAME: 'incoTermName',
  BALANCE: 'balance',
  AUTHORIZED_BY_USER_FULL_NAME: 'authorizedByUserFullName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};
